<template>
  <component
    :is="collapsible ? 'button' : 'div'"
    :type="collapsible ? 'button' : null"
    :aria-expanded="collapsible ? open : null"
    class="section-head"
    :class="{ 'is-collapsible': collapsible, 'is-collapsed': collapsible && !open }"
    :style="{ '--accent': accent }"
    @click="collapsible && $emit('toggle')"
  >
    <i v-if="collapsible" class="bi bi-chevron-down chev" :class="{ 'chev-rot': !open }"></i>
    <i v-if="icon" :class="['bi', icon, 'sec-icon']"></i>
    <h5>{{ title }}</h5>
    <span v-if="badge" class="mode-badge">{{ badge }}</span>

    <span v-if="$slots.summary" class="summary-pills">
      <slot name="summary" />
    </span>

    <slot />
  </component>
</template>

<script setup>
defineProps({
  title: { type:String, required:true },
  badge: { type:String, default:'' },
  accent:{ type:String, default:'var(--stora-accent)' },
  icon:  { type:String, default:'' },
  collapsible: { type:Boolean, default:false },
  open: { type:Boolean, default:true }
})
defineEmits(['toggle'])
</script>

<style scoped>
.section-head.is-collapsible{
  width:100%;
  background:transparent;
  border:0;
  cursor:pointer;
  text-align:left;
  display:flex; align-items:center; gap:.5rem;
  padding-right:.25rem;
  border-radius:8px;
  transition: background-color .15s ease;
}
.section-head.is-collapsible:hover{
  background: color-mix(in srgb, var(--accent) 6%, #fff);
}
.section-head.is-collapsible:focus-visible{
  outline: 2px solid color-mix(in srgb, var(--accent) 60%, #fff);
  outline-offset: 2px;
}
.chev{
  color: var(--accent);
  font-size: 1rem;
  transition: transform .2s ease;
  flex-shrink:0;
}
.chev-rot{ transform: rotate(-90deg); }
.sec-icon{
  color: var(--accent);
  font-size: 1.05rem;
  margin-right: 2px;
}
.summary-pills{
  margin-left:auto;
  font-size:.8rem;
  color:#6b7a86;
  font-weight:500;
  display:inline-flex;
  align-items:center;
  flex-wrap:wrap;
  gap:.5rem;
  padding-right:.5rem;
}
</style>
